import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef
} from 'react';
import { Container } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

type LayoutProps = PropsWithChildren<{
  routes: { [key: string]: any };
  children: React.ReactNode;
}>;
const INACTIVITY_TIMEOUT = 3 * 60 * 1000; // 3 minutos em milissegundos

const DashboardLayout = ({ children, routes }: LayoutProps) => {
  const navigate = useNavigate();
  const inactivityTimeoutRef = useRef<number | null>(null);

  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimeoutRef.current) {
      window.clearTimeout(inactivityTimeoutRef.current);
    }

    inactivityTimeoutRef.current = window.setTimeout(() => {
      navigate('/');
    }, INACTIVITY_TIMEOUT);
  }, [navigate]);

  useEffect(() => {
    // Lista de eventos que resetam o timer de inatividade
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'touchmove'
    ];

    // Inicializa o timer
    resetInactivityTimer();

    // Adiciona os event listeners
    events.forEach((event) => {
      window.addEventListener(event, resetInactivityTimer);
    });

    // Cleanup
    return () => {
      if (inactivityTimeoutRef.current) {
        window.clearTimeout(inactivityTimeoutRef.current);
      }

      events.forEach((event) => {
        window.removeEventListener(event, resetInactivityTimer);
      });
    };
  }, [navigate, resetInactivityTimer]);

  return (
    <div className="w-100 p-0">
      <div className="header-container">
        <main>
          <Container fluid className="p-3 h-100">
            {children}
          </Container>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
